<script setup> 
document.body.addEventListener(
  "touchmove",
  function (e) {
    e.preventDefault();
  },
  {
    passive: !1,
  }
);
import { provide } from "vue";

import useData from "./composables/useData";
provide("useDataHook", useData());

import usePlayer from "./composables/usePlayer";
provide("usePlayerHook", usePlayer());

import { checkAppUserAgent, jsbridge } from "./utils";
provide("isAppEnv", checkAppUserAgent())




</script>

<template>
  <router-view />
</template>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
